export default [
    {
      "value": "Clinica Verde",
      "dispensary_id": "fd140d39-a0e3-4d06-809f-80f5df55317d"
    },
    {
      "value": "Caribbean Medical Center Cannabis",
      "dispensary_id": "190d3d3a-ef92-4100-88ca-08cde5455c9c"
    },
    {
      "value": "TCG Investments",
      "dispensary_id": "43afe6bf-c7f2-47c2-b296-8f1c57f3b86d"
    },
    {
      "value": "Green Health",
      "dispensary_id": "d7a06784-da8f-4187-8df6-b82bbd8c7512"
    },
    {
      "value": "Dispensarios 420",
      "dispensary_id": "d7fc3f3d-62c3-4a8e-b487-ac3ec2f04735"
    },
    {
      "value": "MC Logistic",
      "dispensary_id": "bf9e06f0-bf18-45c4-a798-39d97641ccb7"
    },
    {
      "value": "Caribbean Holistic Group",
      "dispensary_id": "8ee931bc-c365-4039-a4f1-74811d7a2c36"
    },
    {
      "value": "Tetra",
      "dispensary_id": "6f84c338-9adb-4628-b028-676544013625"
    },
    {
      "value": "Herbal Biotech",
      "dispensary_id": "e5014ad9-2267-40ce-845c-3996c6dbd014"
    },
    {
      "value": "Weedco",
      "dispensary_id": "fecaafb6-95cd-4402-a927-d96101c82b86"
    },
    {
      "value": "Firstmedical Cannabis",
      "dispensary_id": "350168b9-2f1b-4fd6-b196-39d471c6bc32"
    },
    {
      "value": "Nirvana",
      "dispensary_id": "e6b94144-a21b-4921-8941-cd1c3e74bddf"
    },
    {
      "value": "Caribbean Green Growers",
      "dispensary_id": "75c31d9b-522f-41df-9b3f-504f6da7aad5"
    },
    {
      "value": "Dorado Green Care",
      "dispensary_id": "b2e4d67c-fcce-4c83-ba54-9c7cdcbfcd4b"
    },
    {
      "value": "Natural Mystic",
      "dispensary_id": "3ec9bd66-4da1-442c-a898-d99ca9a84e55"
    },
    {
      "value": "North West",
      "dispensary_id": "4fb0d7de-7d9f-4eb4-877c-195237dc2799"
    },
    {
      "value": "Earth Gift",
      "dispensary_id": "78c8dbc5-b712-4978-9f02-a71a58039a3c"
    },
    {
      "value": "Fluent",
      "dispensary_id": "81c1aed5-74e6-40b6-b1e3-0d128885c489"
    },
    {
      "value": "B & B Medical Boutique",
      "dispensary_id": "0abfc03b-9b47-4dbe-a3da-587eab0e26b9"
    },
    {
      "value": "Medicated Living",
      "dispensary_id": "6f2e99e0-fb2f-499b-9850-3f78a6e8dfbe"
    },
    {
      "value": "Alternativa",
      "dispensary_id": "703a760a-d36f-4ac0-b8f2-4106604afe60"
    },
    {
      "value": "Herbal Biotech Pathways",
      "dispensary_id": "592629cf-282d-4753-89d4-486ea8a2813e"
    },
    {
      "value": "Casita Verde",
      "dispensary_id": "fb22fefc-f7d1-470a-b8e1-a72cf9c05afd"
    },
    {
      "value": "Natural Wellness Clinic",
      "dispensary_id": "b195d08f-0c9b-430b-960e-c3d0515d764f"
    },
    {
      "value": "Truecannabis",
      "dispensary_id": "66d10fe0-ecb9-400f-a596-e5ef168964ad"
    },
    {
      "value": "Green Heaven",
      "dispensary_id": "54a6d767-65d3-4ca4-af96-bcedbeb00733"
    },
    {
      "value": "Cannateca",
      "dispensary_id": "7a8a1ea6-4418-4141-a2f4-a63939b8a35c"
    },
    {
      "value": "Leafing Life",
      "dispensary_id": "47f5990c-3478-4603-a4be-e6056ffe297d"
    },
    {
      "value": "Alternative Health Solutions",
      "dispensary_id": "ee2ee6e4-79c6-4372-abd3-42701a484911"
    },
    {
      "value": "36 Green Gold Group",
      "dispensary_id": "06810e3c-0989-4de0-9cad-0e8738757301"
    },
    {
      "value": "Sensewave",
      "dispensary_id": "c0eaa91d-e0d7-4e21-994e-5ca5a68909e7"
    },
    {
      "value": "Royal Grass",
      "dispensary_id": "48f9492d-4a21-4efb-a20a-84959716c357"
    },
    {
      "value": "Agronova Corp",
      "dispensary_id": "f2b0d80c-77b9-4c32-b78d-77606344c094"
    },
    {
      "value": "Releaf Solutions",
      "dispensary_id": "988d91f4-f1c1-4d64-b699-66b21175997d"
    },
    {
      "value": "Canna Basics Dispensaries",
      "dispensary_id": "f68f1108-b191-419a-b3a2-fd75e4cd6413"
    },
    {
      "value": "W. Heals",
      "dispensary_id": "af22b4d6-33ad-47bb-8735-a93187324cb3"
    },
    {
      "value": "Best Buds",
      "dispensary_id": "d66f7ce6-f74e-477d-810e-d91eeb5477cf"
    },
    {
      "value": "Casa Verde",
      "dispensary_id": "63e1390f-1ebb-4ead-8088-98d3698974bc"
    },
    {
      "value": "Greencare",
      "dispensary_id": "9ea67cb8-82dd-496e-a8c1-1d64d7b11e75"
    },
    {
      "value": "Cura Verde",
      "dispensary_id": "cdc321e3-7e59-4bf8-8748-fc551f75da13"
    },
    {
      "value": "The Wellness Cannabis",
      "dispensary_id": "76933ae9-0fe8-4371-a26d-2cb5c58f5cd6"
    },
    {
      "value": "Executive Cannabis",
      "dispensary_id": "d4820d66-e28a-44f3-bb94-418ff1057fe6"
    },
    {
      "value": "Asomante",
      "dispensary_id": "8d2c2fd3-45e4-4472-92a6-493272cb8374"
    },
    {
      "value": "Sinsemilla",
      "dispensary_id": "861d7df5-6e51-41fd-9fa9-6f68b8c26ade"
    },
    {
      "value": "Farma Verde",
      "dispensary_id": "00960fca-54e8-4715-bd5f-a685c5644cd0"
    },
    {
      "value": "Dream Cannabis",
      "dispensary_id": "0ad4873b-b96e-40d2-bf6d-c3d37c394c63"
    },
    {
      "value": "The Health Clinic",
      "dispensary_id": "2b11241f-3847-4d87-9f4e-ef4287fa7469"
    },
    {
      "value": "The Bloom Room",
      "dispensary_id": "48903404-f76e-4b63-b989-cb82bdb7d718"
    },
    {
      "value": "True Bloom",
      "dispensary_id": "6d4b6653-7fd5-4b8e-a5a8-267129f6fa0e"
    },
    {
      "value": "Kaizen",
      "dispensary_id": "3961a0bf-a86d-414a-a82e-4d9d92a1ee66"
    },
    {
      "value": "Biogrow",
      "dispensary_id": "34753e6c-9305-4538-aa79-3fd870c67c10"
    },
    {
      "value": "Turf Cannabis Collection",
      "dispensary_id": "1fabb46e-3faa-4034-b9eb-6fd3ab41f925"
    },
    {
      "value": "Healthy Pure",
      "dispensary_id": "048f04f7-ebea-4b60-980c-135d427249e0"
    },
    {
      "value": "Buds Cannabis Dispensary",
      "dispensary_id": "473debca-4044-43a5-9a2a-e23bbf38f825"
    },
    {
      "value": "Cannabliss",
      "dispensary_id": "b5e2237c-7e9b-4c83-b92a-f7de33ef4368"
    },
    {
      "value": "Healthweed",
      "dispensary_id": "23f2eec3-8f12-44ed-b5c5-21df58d31d3f"
    },
    {
      "value": "Elementos",
      "dispensary_id": "14c3c507-a81e-41de-9cc6-c8f6ff314080"
    },
    {
      "value": "Solucion Natural",
      "dispensary_id": "e6122e05-77d3-42c9-a47e-c0ad5c225f2a"
    },
    {
      "value": "Borincanna",
      "dispensary_id": "8732cef4-d24a-4bfa-b466-b856416b25c4"
    },
    {
      "value": "Nextgen",
      "dispensary_id": "ef1ffe52-904b-4e42-b828-b3c7642ba28c"
    },
    {
      "value": "Marimed",
      "dispensary_id": "9b0b4eb0-9b70-4daf-a2b3-439a784e2122"
    },
    {
      "value": "TWC",
      "dispensary_id": "8f6ed79f-f7f0-408d-8bcc-5cae9ef93a91"
    },
    {
      "value": "Four Point",
      "dispensary_id": "5e996fa5-62b3-432d-a111-e5bb55b66e82"
    },
    {
      "value": "Frontiers",
      "dispensary_id": "c2a178e6-0ed4-471c-9adc-11ddd5627bb7"
    },
    {
      "value": "Yes I Cann",
      "dispensary_id": "5653de2d-8185-4f42-b296-bf95f07a79ad"
    },
    {
      "value": "Alternative Therapy",
      "dispensary_id": "6a863e47-b816-46d4-8583-aa5c5f652c87"
    },
    {
      "value": "Punto Verde Medical",
      "dispensary_id": "e7f9a7dc-3b2e-4386-bf6e-8d06160ec17e"
    },
    {
      "value": "Senses Med Center",
      "dispensary_id": "70a5679b-5547-461e-8edb-aa557cf9ea78"
    },
    {
      "value": "B Well",
      "dispensary_id": "f1ccb681-7bf9-493a-a0b5-a28640d38c13"
    },
    {
      "value": "The Health Teapot",
      "dispensary_id": "22daca5d-87b2-420c-891f-78bdfc1e7b3e"
    },
    {
      "value": "Leafwell",
      "dispensary_id": "6f02a1e7-d257-4369-94a3-c88b941b8844"
    },
    {
      "value": "Cannassense",
      "dispensary_id": "434abac2-684b-42ef-a08e-09c0652b0202"
    },
    {
      "value": "New Era Pharmaceutical Products",
      "dispensary_id": "a310da2e-a6c6-4cdc-9b9f-79b429344d78"
    },
    {
      "value": "Aguada Emerald",
      "dispensary_id": "e05baa54-325c-485a-9ef5-7e61877fcf6b"
    },
    {
      "value": "[Vur Jer]",
      "dispensary_id": "fbfe983d-6e3f-47cf-992a-95b0b68b130b"
    },
    {
      "value": "Puerto Rico Chronic Relief",
      "dispensary_id": "575a008c-e038-4115-8384-c8b87d058199"
    },
    {
      "value": "Cannacity Clinic",
      "dispensary_id": "1fe7c149-a615-475c-9489-3de383a37b3f"
    },
    {
      "value": "Prestige",
      "dispensary_id": "6abc2a06-eba0-4ee9-b9c7-5410173eb57e"
    },
    {
      "value": "Nova Wellness",
      "dispensary_id": "3e05bd59-0237-498d-bf4b-d13309daad5a"
    },
    {
      "value": "Cush",
      "dispensary_id": "f40b389c-30da-4fb6-bbbb-d6431e8c5774"
    },
    {
      "value": "Green Spirit Rx",
      "dispensary_id": "5ea2ba8a-ea4a-4dc0-af15-bcc823b477cf"
    },
    {
      "value": "3G Gold Group",
      "dispensary_id": "d23e348d-064f-48ca-b1fa-2b8a513ed13c"
    },
    {
      "value": "Puerto Rico Medical Cannabis",
      "dispensary_id": "ce0152ed-4d4e-407a-bd65-e724a7a66056"
    },
    {
      "value": "Pura Cepa",
      "dispensary_id": "330c5c5f-5c9d-4444-a964-fc483ec624f9"
    },
    {
      "value": "Green Doctor",
      "dispensary_id": "653a6afb-1275-416b-80b9-d25371937ebe"
    },
    {
      "value": "Frontiers Properties",
      "dispensary_id": "b1c98a50-d525-4f11-b73d-f07e8910f3de"
    },
    {
      "value": "Sabia",
      "dispensary_id": "80f07d11-9427-4dd0-be55-44cc86630827"
    },
    {
      "value": "Mirajuana",
      "dispensary_id": "24557e9c-f80d-4782-b508-939f5372b751"
    },
    {
      "value": "Island Extract",
      "dispensary_id": "efeb8c74-d213-4a11-9a8f-34178efc0cac"
    },
    {
      "value": "Cultive Culture",
      "dispensary_id": "05ee493e-a067-40ce-86c3-1f870110c7c9"
    },
    {
      "value": "Puerto Rico Cannabis Co.",
      "dispensary_id": "069e286e-7967-4226-8aa7-6432464abbb4"
    },
    {
      "value": "Inhale",
      "dispensary_id": "b0086519-1eee-48b1-8505-00203561dfa7"
    },
    {
      "value": "Cannabistik",
      "dispensary_id": "f8a05314-a9a6-4491-8a5b-00d0f05ed812"
    },
    {
      "value": "Weeds",
      "dispensary_id": "dfb450c8-2dfd-4806-9192-91481cf368bd"
    },
    {
      "value": "Encasa",
      "dispensary_id": "cca34a24-023a-4efa-b802-dcf4a6d31dba"
    },
    {
      "value": "Green Mile",
      "dispensary_id": "e50c8cd1-d771-43a4-8058-a103f0308fbd"
    },
    {
      "value": "El Medicinal",
      "dispensary_id": "a3c1f235-e244-4980-a85e-a44c1ebe8adf"
    },
    {
      "value": "Caramor",
      "dispensary_id": "7cee9544-da04-4ce4-b41e-8912c7fb3189"
    },
    {
      "value": "Dispensario Farmaverde La Central",
      "dispensary_id": "e905a700-758e-495d-b87e-e74c1f36a5e7"
    },
    {
      "value": "C Grove",
      "dispensary_id": "aad56511-c23c-4d3a-8280-4522c978225f"
    },
    {
      "value": "Pharmabis Cannabis Dispensary",
      "dispensary_id": "bee94c8a-6b70-44db-aea1-8e482bfec518"
    },
    {
      "value": "Healing Zone",
      "dispensary_id": "d6bd87f6-99c5-4029-8476-39a2c3a6b556"
    },
    {
      "value": "Cataleya",
      "dispensary_id": "0ff29c35-2133-4b0b-a01d-8031186f474f"
    },
    {
      "value": "Essence Cannabis",
      "dispensary_id": "ccf6a985-1878-472f-b0c2-af8e54cef651"
    },
    {
      "value": "Green House",
      "dispensary_id": "ef97a1a8-23dd-4cb4-b702-c59d47c080f1"
    },
    {
      "value": "Med Leaf",
      "dispensary_id": "c1b78720-2b5d-4c68-a185-213d01ff99da"
    }
  ]